import { render } from "./BrandSidebar.vue?vue&type=template&id=19c96eaa"
import script from "./BrandSidebar.vue?vue&type=script&lang=js"
export * from "./BrandSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__